app
    .controller('ChatButtonController', function ChatButtonController(ChatService) {
        this.open = () => {
            ChatService.openChat(this.receiver, this.isConnected);
        };

        this.isVisible = () => {
            return !ChatService.isLoading && ChatService.sender && ChatService.sender._id !== this.receiver._id;
        };
    })
    .component('chatButton', {
        template: `<button class="{{ $ctrl.btnClass || 'btn btn-light' }}" ng-click="$ctrl.open()" ng-disable="!$ctrl.isVisible()">
            <chat-icon width="15" height="15" type="message"></chat-icon>
            {{ $ctrl.btnText || "Send Message"}}
        </button>`,
        bindings: {
            receiver: '=',
            isConnected: '=',
            btnClass: '@',
            btnText: '@',
        },
        controller: 'ChatButtonController'
    });
